import React from "react";
import DashboardComponent from "../../components/Dashboard/Dashboard";

const Dashboard = () => {
  return <DashboardComponent />;
};

export default Dashboard;
